import { useQuery } from '@tanstack/react-query'
import { api } from '@api'
import { useCurrentUserStore } from '@store'

// Same polling rationale as useUnreadNotificationsCount: no realtime channel on
// web, so a short interval keeps the "Messagerie" badge close to real time.
const UNREAD_REFETCH_INTERVAL_MS = 30_000

export const UNREAD_CONVERSATIONS_QUERY_KEY = ['conversations', 'unread-count'] as const

const fetchUnreadConversationsCount = async (): Promise<number> => {
  const { data } = await api.get<{ count: number }>('/conversations/unread-count')
  return data.count ?? 0
}

/**
 * Number of conversations with unread messages, used to badge the "Messagerie"
 * entry in the navigation menu. Returns 0 until the first fetch resolves and
 * while logged out.
 */
export const useUnreadConversationsCount = (): { unreadCount: number } => {
  const { userID } = useCurrentUserStore()

  const { data: unreadCount = 0 } = useQuery({
    queryKey: UNREAD_CONVERSATIONS_QUERY_KEY,
    queryFn: fetchUnreadConversationsCount,
    enabled: !!userID,
    refetchInterval: UNREAD_REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: true,
  })

  return { unreadCount }
}
